import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { OrderService } from "../../../orders/services/order.service";
import { MyCardOrderItems, DownlaodCardOrderItems, MyCardOrderItemsGrade, gradeitems, CheckDownlaodCardOrderItems, ShippedCardOrders } from "../../../orders/models/order";
import { FilterSettingsModel, IFilter, TextWrapSettingsModel, PageSettingsModel, } from '@syncfusion/ej2-angular-grids';
import { StateService } from "../../../common/services/state.service";
import { User } from "../../../common/models/user";
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';
import * as _ from 'lodash';
import { ModalService } from '../../../common/services/modal.service';
import { ToastrService } from 'ngx-toastr';
import { PopReportsService } from '../../../pop-reports/services/pop-reports.service';
import { PopPipelineStatus, PopReportAuthCode } from '../../../pop-reports/models/PopulationReport';
import { UserService } from '../../../common/services/user.service';
import { Ribbon, TabSelectingEventArgs, RibbonButtonSettingsModel, RibbonComboBoxSettingsModel, RibbonItemSize, RibbonCheckBoxSettingsModel, RibbonTabModel } from '@syncfusion/ej2-ribbon';
import { Subscription, interval, switchMap } from 'rxjs';
import { Router } from '@angular/router';


@Component({
    selector: 'app-mycards',
    templateUrl: './mycards.component.html',
    styleUrls: ['./mycards.component.css',
        './myCardsBootstrap.component.css',
        './mycards-download.component.css'
    ],
    standalone: false
})
export class MycardsComponent implements OnInit, OnDestroy {

  constructor(
    private toastr: ToastrService,
    private modalService: ModalService,
    private orderService: OrderService,
    private stateService: StateService,
    private router: Router,
    private formBuilder: FormBuilder,
    private popReportsService: PopReportsService,
    private userService: UserService
  ) { }


  @ViewChild('backstageRibbon', { static: false }) ribbonObj!: Ribbon;
  private fetchInterval!: Subscription;
  form!: FormGroup;

  authCodeResult = new PopReportAuthCode();
  currentUser = new User();
  PopPipelineStatus: PopPipelineStatus[] = [];
  public downlaodCardOrderItems: DownlaodCardOrderItems[] = []
  MyCardOrderItems: MyCardOrderItems[] = [];
  MyCardOrderItemsForGradeOrBetter: MyCardOrderItemsGrade[] = [];
  public allGradeItems: gradeitems[] = [];


  public format = { type: 'date',format: 'MM/dd/yyyy hh:mm:ss a' }
  public FilterOptions: FilterSettingsModel = { type: 'Menu', };
  public filter: IFilter = { params: { format: 'MM/dd/yyyy' } };
  convertUtcToEst(dateString: string): string {
    if (dateString === "0001-01-01T00:00:00" || dateString === "" || dateString === "-") {
      return "-";
    }
    
    const utcDate = new Date(dateString + 'Z');

    const estDateString = utcDate.toLocaleString('en-US', {
      timeZone: 'America/New_York',
      year: 'numeric',
      month: '2-digit',
      day: '2-digit',
      hour: '2-digit',
      minute: '2-digit',
      second: '2-digit',
      hour12: true
    });

    return estDateString +' EST';
  }

 
  public pageSettings!: PageSettingsModel;
  public wrapSettings!: TextWrapSettingsModel;

  checkDownlaodCardOrderItems!: CheckDownlaodCardOrderItems[];
  allCheckDownlaodCardOrderItems!: CheckDownlaodCardOrderItems[];
  allShippedCardOrders!: ShippedCardOrders[];
  isOrderAddCard: boolean = false;

  showgradeSubject: boolean = false;
  isAuthCodeRefreshing: boolean = false;
  authcertcode: any;
  showCertCodeMsg: boolean = false;
  cardAddedStatus: string = "";
  PopLineheck: boolean = true;
  authcertcodelength: boolean = false;
  btnAuthPopLoad: boolean = false;
  h275FrontImage: any;
  h275BackImage: any;

  currentCardGrid: number = 0;
  TotalorderItemGuidList: number = 0;
  currentStep: number = 0;
  cardsMsg: string = "";
  msgColor: string = "";
  allOrderItemGuidList: any = "";
  isRibbonInit: boolean = false;

  isCardsLoading: boolean = false;


  grades: any = "";
  availableForDownload: number = 0;
  willBeReadySoon: number = 0;
  cardDownloadType: any = "";

  public largeSize: RibbonItemSize = RibbonItemSize.Large;
  public smallSize: RibbonItemSize = RibbonItemSize.Small;
  public PDownloadTab: RibbonTabModel = { id: "PDownloads", header: 'Pending Downloads' };
  public cardAddButton: RibbonButtonSettingsModel = { iconCss: "e-icons e-plus-2", content: "Add Card(s)", clicked: () => { this.certCodeLookup(); } };
  public downlaodAddButton: RibbonButtonSettingsModel = { iconCss: "e-icons e-download", content: "Download", cssClass: 'e-download-button', clicked: () => { this.DownloadAll(); } };
  public AddPreviousButton: RibbonButtonSettingsModel = { content: "Add All Cards On Order", cssClass: 'e-plus-button', clicked: () => { this.AddShippedOrderToCard(); } };

  selectedSport: any;
  public sportDdl: RibbonComboBoxSettingsModel = {
    dataSource: [], width: '180px', popupWidth: '180px', placeholder: 'Sport', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        this.selectedSport = args.itemData.text;
        this.filterItems();
      }
      else {
        this.selectedSport = null;
        this.filterItems();
      }
    }
  };
  selectedSet: any;
  public setDdl: RibbonComboBoxSettingsModel = {
    dataSource: [], width: '180px', popupWidth: 'auto', placeholder: 'Set', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        this.selectedSet = args.itemData.text;
        this.filterItems();
      }
      else {
        this.selectedSet = null;
        this.filterItems();
      }
    }
  };
  selectedSubject: any;
  public subjectDdl: RibbonComboBoxSettingsModel = {
    dataSource: [], width: '180px', popupWidth: 'auto', placeholder: 'Subject', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        this.selectedSubject = args.itemData.text;
        this.filterItems();
      }
      else {
        this.selectedSubject = null;
        this.filterItems();
      }
    }
  };
  selectedYearFrom: any;
  public yearFromDdl: RibbonComboBoxSettingsModel = {
    dataSource: [], width: '180px', popupWidth: '180px', placeholder: 'Year From', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        this.selectedYearFrom = args.itemData.text;
        this.filterItems();
      }
      else {
        this.selectedYearFrom = null;
        this.filterItems();
      }
    }
  };
  selectedYearTo: any;
  public yearToDdl: RibbonComboBoxSettingsModel = {
    dataSource: [], width: '180px', popupWidth: '180px', placeholder: 'Year To', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        this.selectedYearTo = args.itemData.text;
        this.filterItems();
      }
      else {
        this.selectedYearTo = null;
        this.filterItems();
      }
    }
  };
  selectedCardNo: any;
  public itemNumberDdl: RibbonComboBoxSettingsModel = {
    dataSource: [], width: '180px', popupWidth: '180px', placeholder: '#', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        this.selectedCardNo = args.itemData.text;
        this.filterItems();
      }
      else {
        this.selectedCardNo = null;
        this.filterItems();
      }
    }
  };
  selectedGrade: any;
  public gradeDdl: RibbonComboBoxSettingsModel = {
    dataSource: [], width: '140px', popupWidth: '140px', placeholder: 'Grade', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        this.selectedGrade = args.itemData.text;
        this.filterItems();
      }
      else {
        this.selectedGrade = null;
        this.filterItems();
      }
    }
  };
  selectedCertCode: any;
  public certCodeDdl: RibbonComboBoxSettingsModel = {
    dataSource: [], width: '140px', popupWidth: '140px', placeholder: 'Cert. Code', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        this.selectedCertCode = args.itemData.text;
        this.filterItems();
      }
      else {
        this.selectedCertCode = null;
        this.filterItems();
      }
    }
  };
  selectedOrdNo: any;
  public ordNoDdl: RibbonComboBoxSettingsModel = {
    dataSource: [], width: '140px', popupWidth: '140px', placeholder: 'Order No.', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        this.selectedOrdNo = args.itemData.value;
        this.filterItems();
      }
      else {
        this.selectedOrdNo = null;
        this.filterItems();
      }
    }
  };
  selectedShpOrdNo: any;
  public ShpOrdNoDdl: RibbonComboBoxSettingsModel = {
    dataSource: [], width: '160px', popupWidth: '160px', placeholder: 'Order No.', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        this.selectedShpOrdNo = args.itemData.value;
      }
      else {
        this.selectedShpOrdNo = null;
      }
    }
  };

  selectedAutoOnly: boolean = false;
  public autoOnlyChkB: RibbonCheckBoxSettingsModel = { label: "Autos Only", checked: false, change: (args) => { this.selectedAutoOnly = args.checked; this.filterItems(); } };
  selectedGradeOrBetter: boolean = false;
  public gradeOrBetterChk: RibbonCheckBoxSettingsModel = { label: "This Grade or Better", checked: false, change: (args) => { this.selectedGradeOrBetter = args.checked; this.filterItems(); } };

  public listButton: RibbonButtonSettingsModel = { iconCss: "e-icons e-level-1", content: "List", clicked: () => { this.ShowoneCol(); } };
  public gallery6Button: RibbonButtonSettingsModel = { iconCss: "e-icons e-grip-vertical", content: "Gallery 6", clicked: () => { this.ShowsixCol(); } };
  public gallery4Button: RibbonButtonSettingsModel = { iconCss: "e-icons e-level-4", content: "Gallery 4", clicked: () => { this.ShowfourCol(); } };
  public gallery2Button: RibbonButtonSettingsModel = { iconCss: "e-icons e-level-2", content: "Gallery 2", clicked: () => { this.ShowtwoCol(); } };

  public selectAllButFilter: RibbonButtonSettingsModel = { iconCss: "e-icons e-select-all", content: "Select All Cards", clicked: () => { this.selectall(); } };
  public clearAllButFilter: RibbonButtonSettingsModel = { iconCss: "e-icons e-erase", content: "Clear Selection", clicked: () => { this.clearall(); } };

  selectedDownloadType: any;
  public downlaodTypeData: string[] = ["Front & Back", "Front Only", "Back Only"];
  public downlaodTypeDdl: RibbonComboBoxSettingsModel = {
    dataSource: this.downlaodTypeData, width: '140px', popupWidth: '140px', placeholder: 'Download Type', autofill: false, allowFiltering: true,
    change: (args) => {
      if (args.itemData) {
        if (args.itemData.text == 'Front & Back') {
          this.selectedDownloadType = '_F_B';
        }
        if (args.itemData.text == 'Front Only') {
          this.selectedDownloadType = '_F';
        }
        if (args.itemData.text == 'Back Only') {
          this.selectedDownloadType = '_B';
        }
      }
      else {
        this.selectedDownloadType = null;
      }
    }
  };

  ngOnInit() {
    this.pageSettings = { pageSize: 10, pageCount: 4 };
    this.wrapSettings = { wrapMode: 'Both' };
    this.stateService.currentUser.changes.subscribe(user => { this.currentUser = user; });

    this.selectedSport = null;
    this.selectedSet = null;
    this.selectedSubject = null;
    this.selectedYearFrom = null;
    this.selectedYearTo = null;
    this.selectedCardNo = null;
    this.selectedGrade = null;
    this.selectedCertCode = null;
    this.selectedOrdNo = null;
    this.selectedDownloadType = null;

    this.buildForm();
    this.setAuthcodeValidators();

    this.CheckCardDownloadStatus();
    this.PageMainCall();
    this.cardDownloadType = 'completed';
    this.GetShippedOrdersByUserId();

    this.fetchInterval = interval(120000).pipe(switchMap(() => this.orderService.GetStatusForDownloadCards(this.currentUser.id))).subscribe(response => {
      this.allCheckDownlaodCardOrderItems = response;
      if (this.cardDownloadType == 'completed') {
        this.checkDownlaodCardOrderItems = this.allCheckDownlaodCardOrderItems.filter(item => item.zipRequestState === 3);
      }
      if (this.cardDownloadType == 'pending') {
        this.checkDownlaodCardOrderItems = this.allCheckDownlaodCardOrderItems.filter(item => item.zipRequestState != 3);
      }

      let availableForDownloadCount = 0;
      let willBeReadySoonCount = 0;
      for (let item of this.allCheckDownlaodCardOrderItems) {
        if (item.zipRequestState == 3) {
          item.zipRequestStateStatus = "Available For Download";
          availableForDownloadCount++;
        }
        else {
          item.zipRequestStateStatus = "Will Be Ready Soon";
          willBeReadySoonCount++;
        }
        if (item.zipGeneratedOn == "0001-01-01T00:00:00") {
          item.zipGeneratedOn = "";
        }
      }

      this.availableForDownload = availableForDownloadCount;
      this.willBeReadySoon = willBeReadySoonCount;

      if (this.willBeReadySoon > 0) {
        if (this.ribbonObj) {
          const tabadd = this.ribbonObj.tabsInternal[3];
          if (!tabadd || tabadd == undefined) {
            this.ribbonObj.addTab(this.PDownloadTab);
          }
          this.PDownloadTab = { ...this.PDownloadTab, header: "Pending Downloads " + "(" + this.willBeReadySoon + ")" };
          this.ribbonObj.updateTab(this.PDownloadTab);
        }
      }
      else {
        if (this.ribbonObj) {
          const tabadd = this.ribbonObj.tabsInternal[3];
          if (tabadd) {
            this.ribbonObj.removeTab('PDownloads');
          }
        }
      }
    });
  }


  public tabSelecting(args: TabSelectingEventArgs) {
    this.cardsMsg = "";
    this.msgColor = "";
    if (args.selectedIndex == 0) {
      this.home();
    }
    if (args.selectedIndex == 1) {
      this.certCodeLookup();
    }
    if (args.selectedIndex == 2) {
      this.currentStep = 3;
      this.cardDownloadGrid('completed');
    }
    if (args.selectedIndex == 3) {
      this.currentStep = 3;
      this.cardDownloadGrid('pending');
    }
  }
  home() {
    this.currentStep = 1;
  }

  cardDownloadGrid(downloadType: string) {
    if (downloadType == 'completed') {
      this.cardDownloadType = 'completed';
      this.checkDownlaodCardOrderItems = this.allCheckDownlaodCardOrderItems.filter(item => item.zipRequestState === 3);
    }
    else {
      this.cardDownloadType = 'pending';
      this.checkDownlaodCardOrderItems = this.allCheckDownlaodCardOrderItems.filter(item => item.zipRequestState != 3);
      this.willBeReadySoon = this.checkDownlaodCardOrderItems.length;
    }

    if (this.willBeReadySoon > 0) {
      if (this.ribbonObj) {
        const tabadd = this.ribbonObj.tabsInternal[3];
        if (!tabadd || tabadd == undefined) {
          this.ribbonObj.addTab(this.PDownloadTab);
        }
        this.PDownloadTab = { ...this.PDownloadTab, header: "Pending Downloads " + "(" + this.willBeReadySoon + ")" };
        this.ribbonObj.updateTab(this.PDownloadTab);
      }
    }
    else {
      if (this.ribbonObj) {
        const tabadd = this.ribbonObj.tabsInternal[3];
        if (tabadd) {
          this.ribbonObj.removeTab('PDownloads');
        }
      }
    }
  }
  certCodeLookup() {
    this.currentStep = 2;
    this.selectedShpOrdNo = null;
    this.selectedShpOrdNo = null;
    this.isOrderAddCard = false;
    this.authcertcode = "";
    this.PopLineheck = true;
    this.showCertCodeMsg = false;
    this.authcertcodelength = false;
    this.btnAuthPopLoad = false;
    this.cardAddedStatus = "";
    this.form.controls['authcode'].setValue('');
    this.authCodeResult = new PopReportAuthCode();
  }

  PageMainCall() {
    this.isRibbonInit = true;
    this.ShowsixCol();
    this.getallCards();
    this.isRibbonInit = false;
  }
  GetShippedOrdersByUserId() {
    this.orderService.GetShippedOrdersByUserId(this.currentUser.id).subscribe(response => {
      this.allShippedCardOrders = response;
      this.bindRibbonOrderData();
    });
  }
  AddShippedOrderToCard() {
    this.msgColor = "";
    this.cardsMsg = "";
    this.isOrderAddCard = true;
    if (this.selectedShpOrdNo) {
      this.orderService.AddShippedOrderToCard(this.currentUser.id, this.selectedShpOrdNo).subscribe(response => {
        this.isOrderAddCard = false;
        if (response.ok) {
          this.getallCards();
          this.msgColor = "green";
          this.cardsMsg = "Success! The graded cards from the order you selected will be added shortly.";
        }
        else {
          if (response.error && response.error.text === 'CardAlreadyExist') {
            this.msgColor = "red";
            this.cardsMsg = "This card is already in your My Cards.";
          }
          else if (response.error && response.error.text === 'CardNotAdded') {
            this.msgColor = "red";
            this.cardsMsg = "The Cards in the selected Order will not be added.Please contact SGC support.";
          } else if (response.error && response.error.text === 'CardAdded') {
            this.getallCards();
            this.msgColor = "green";
            this.cardsMsg = "Success! The graded cards from the order you selected will be added shortly.";
          }
        }
      });
    }
    else {
      this.msgColor = "red";
      this.cardsMsg = "Please select an order number from the dropdown list and click the \"Add All Cards On Order\"";
    }

  }
  CheckCardDownloadStatus() {
    this.orderService.GetStatusForDownloadCards(this.currentUser.id).subscribe(response => {
      this.allCheckDownlaodCardOrderItems = response;

      if (this.cardDownloadType == 'completed') {
        this.checkDownlaodCardOrderItems = this.allCheckDownlaodCardOrderItems.filter(item => item.zipRequestState === 3);
      }
      if (this.cardDownloadType == 'pending') {
        this.checkDownlaodCardOrderItems = this.allCheckDownlaodCardOrderItems.filter(item => item.zipRequestState != 3);
      }

      let availableForDownloadCount = 0;
      let willBeReadySoonCount = 0;
      for (let item of this.allCheckDownlaodCardOrderItems) {
        if (item.zipRequestState == 3) {
          item.zipRequestStateStatus = "Available For Download";
          availableForDownloadCount++;
        }
        else {
          item.zipRequestStateStatus = "Will Be Ready Soon";
          willBeReadySoonCount++;
        }
        if (item.zipGeneratedOn == "0001-01-01T00:00:00") {
          item.zipGeneratedOn = "-";
        }
      }
      this.availableForDownload = availableForDownloadCount;
      this.willBeReadySoon = willBeReadySoonCount;

      if (this.willBeReadySoon > 0) {
        if (this.ribbonObj) {
          const tabadd = this.ribbonObj.tabsInternal[3];
          if (!tabadd || tabadd == undefined) {
            this.ribbonObj.addTab(this.PDownloadTab);
          }
          this.PDownloadTab = { ...this.PDownloadTab, header: "Pending Downloads " + "(" + this.willBeReadySoon + ")" };
          this.ribbonObj.updateTab(this.PDownloadTab);
        }
      }
      else {
        if (this.ribbonObj) {
          const tabadd = this.ribbonObj.tabsInternal[3];
          if (tabadd) {
            this.ribbonObj.removeTab('PDownloads');
          }
        }
      }
    });
  }
  download(zipUrl: any) {
    const blob = new Blob([zipUrl], {
      type: 'application/zip'
    });
    const url = window.URL.createObjectURL(blob);
    window.open(url);
  }
  getCardGrade(item: MyCardOrderItems): string {
    if (item.cardRejectionDescription != null && (item.cardGrade == '0 A' || item.cardGrade == 'AUTHENTIC')) {
      var grd = item.cardGrade + ' ' + item.cardRejectionDescription
      return grd;
    }
    else
      return item.cardGrade;
  }
  onImgError(item: MyCardOrderItems, event: any) {
    event.target.src = 'assets/img/sgcNoImageAvailable.jpg';
  }
  bindRibbonData() {
    const sprt = this.MyCardOrderItemsForGradeOrBetter.map(item => item.sport)
      .filter((value, index, self) => self.indexOf(value) === index);
    sprt.sort();

    const uniqueOrderNumbers = this.MyCardOrderItemsForGradeOrBetter.filter(item => item.myCardOwnerId === this.currentUser.id && item.myCardOwnerId !== '0')
      .map(item => item.orderNumber)
      .filter((value, index, self) => self.indexOf(value) === index);
    uniqueOrderNumbers.sort((a: any, b: any) => (a > b ? -1 : 1))

    const certCode = this.MyCardOrderItemsForGradeOrBetter.map(item => item.certificationCode)
      .filter((value, index, self) => self.indexOf(value) === index);
    certCode.sort((a: any, b: any) => (a > b ? -1 : 1))

    this.grades = this.MyCardOrderItemsForGradeOrBetter.map(item => item.cardGrade)
      .filter((value, index, self) => self.indexOf(value) === index);

    const set = this.MyCardOrderItemsForGradeOrBetter.map(item => item.cardSet)
      .filter((value, index, self) => self.indexOf(value) === index);
    set.sort((a: any, b: any) => (a > b ? -1 : 1))

    const yFrom = this.MyCardOrderItemsForGradeOrBetter.map(item => item.yearFrom)
      .filter((value, index, self) => self.indexOf(value) === index);
    yFrom.sort((a: any, b: any) => (a > b ? -1 : 1))

    const yTo = this.MyCardOrderItemsForGradeOrBetter.map(item => item.yearTo)
      .filter((value, index, self) => self.indexOf(value) === index);
    yTo.sort((a: any, b: any) => (a > b ? -1 : 1))

    const cSubject = this.MyCardOrderItemsForGradeOrBetter.map(item => item.cardSubject)
      .filter((value, index, self) => self.indexOf(value) === index);
    cSubject.sort((a: any, b: any) => (a > b ? -1 : 1))

    const itemNumber = this.MyCardOrderItemsForGradeOrBetter.map(item => item.cardNumber)
      .filter((value, index, self) => self.indexOf(value) === index);
    itemNumber.sort((a: any, b: any) => (a > b ? -1 : 1))


    this.ordNoDdl.dataSource = uniqueOrderNumbers;
    this.sportDdl.dataSource = sprt;
    this.setDdl.dataSource = set;
    this.yearFromDdl.dataSource = yFrom;
    this.yearToDdl.dataSource = yTo;
    this.subjectDdl.dataSource = cSubject;
    this.itemNumberDdl.dataSource = itemNumber;
    this.certCodeDdl.dataSource = certCode;

    //this.sportDdl = { ...this.sportDdl, dataSource: sprt };
    //this.setDdl = { ...this.setDdl, dataSource: set };
    //this.yearFromDdl = { ...this.yearFromDdl, dataSource: yFrom };
    //this.yearToDdl = { ...this.yearToDdl, dataSource: yTo };
    //this.subjectDdl = { ...this.subjectDdl, dataSource: cSubject };
    //this.itemNumberDdl = { ...this.itemNumberDdl, dataSource: itemNumber };
    //this.certCodeDdl = { ...this.certCodeDdl, dataSource: certCode };

    this.allGradeItems = []
    const uniqueGrades = new Set();
    for (let item of this.grades) {

      if (item != null) {
        let gradeitem = new gradeitems();
        if (item == "10 PRI") {
          gradeitem.grade = "10 PRI";
          gradeitem.gradevalue = 1;
        }
        if (item == "10 GM") {
          gradeitem.grade = "10 GM";
          gradeitem.gradevalue = 2;
        }
        if (item == "9.5 MT+") {
          gradeitem.grade = "9.5 MT+";
          gradeitem.gradevalue = 3;
        }
        if (item == "9 MT") {
          gradeitem.grade = "9 MT";
          gradeitem.gradevalue = 4;
        }
        if (item == "8.5 NM MT+") {
          gradeitem.grade = "8.5 NM MT+";
          gradeitem.gradevalue = 5;
        }
        if (item == "8 NM MT") {
          gradeitem.grade = "8 NM MT";
          gradeitem.gradevalue = 6;
        }
        if (item == "7.5 NM+") {
          gradeitem.grade = "7.5 NM+";
          gradeitem.gradevalue = 7;
        }
        if (item == "7 NM") {
          gradeitem.grade = "7 NM";
          gradeitem.gradevalue = 8;
        }
        if (item == "6.5 EX NM+") {
          gradeitem.grade = "6.5 EX NM+";
          gradeitem.gradevalue = 9;
        }
        if (item == "6 EX NM") {
          gradeitem.grade = "6 EX NM";
          gradeitem.gradevalue = 10;
        }
        if (item == "5.5 EX+") {
          gradeitem.grade = "5.5 EX+";
          gradeitem.gradevalue = 11;
        }
        if (item == "5 EX") {
          gradeitem.grade = "5 EX";
          gradeitem.gradevalue = 12;
        }
        if (item == "4.5 VG EX+") {
          gradeitem.grade = "4.5 VG EX+";
          gradeitem.gradevalue = 13;
        }
        if (item == "4 VG EX") {
          gradeitem.grade = "4 VG EX";
          gradeitem.gradevalue = 14;
        }
        if (item == "3.5 VG+") {
          gradeitem.grade = "3.5 VG+";
          gradeitem.gradevalue = 15;
        }
        if (item == "3 VG") {
          gradeitem.grade = "3 VG";
          gradeitem.gradevalue = 16;
        }
        if (item == "2.5 GD+") {
          gradeitem.grade = "2.5 GD+";
          gradeitem.gradevalue = 17;
        }
        if (item == "2 GD") {
          gradeitem.grade = "2 GD";
          gradeitem.gradevalue = 18;
        }
        if (item == "1.5 FR") {
          gradeitem.grade = "1.5 FR";
          gradeitem.gradevalue = 19;
        }
        if (item == "1 PR") {
          gradeitem.grade = "1 PR";
          gradeitem.gradevalue = 20;
        }
        if (item == "AUTHENTIC" || item == "0 A") {
          gradeitem.grade = "AUTHENTIC";
          gradeitem.gradevalue = 21;
        }
        if (!uniqueGrades.has(gradeitem.grade)) {
          this.allGradeItems.push(gradeitem);
          uniqueGrades.add(gradeitem.grade);
        }
      }
    }
    this.allGradeItems.sort((a, b) => (a.gradevalue < b.gradevalue) ? -1 : 1);
    const gradeValues = this.allGradeItems.map(item => item.grade);

    //this.gradeDdl = { ...this.gradeDdl, dataSource: gradeValues };
    this.gradeDdl.dataSource = gradeValues;

    if (this.ribbonObj) {
      this.ribbonObj.ribbonComboBoxModule.updateComboBox(this.ordNoDdl, 'ordNoDdl');
      this.ribbonObj.ribbonComboBoxModule.updateComboBox(this.sportDdl, 'sportDdl');
      this.ribbonObj.ribbonComboBoxModule.updateComboBox(this.setDdl, 'setDdl');
      this.ribbonObj.ribbonComboBoxModule.updateComboBox(this.yearFromDdl, 'yearFromDdl');
      this.ribbonObj.ribbonComboBoxModule.updateComboBox(this.yearToDdl, 'yearToDdl');
      this.ribbonObj.ribbonComboBoxModule.updateComboBox(this.subjectDdl, 'subjectDdl');
      this.ribbonObj.ribbonComboBoxModule.updateComboBox(this.itemNumberDdl, 'itemNumberDdl');
      this.ribbonObj.ribbonComboBoxModule.updateComboBox(this.certCodeDdl, 'certCodeDdl');
      this.ribbonObj.ribbonComboBoxModule.updateComboBox(this.gradeDdl, 'gradeDdl');
    }
  }
  bindRibbonOrderData() {
    const shpOrders = this.allShippedCardOrders.map(item => String(item.orderNumber));
    this.ShpOrdNoDdl.dataSource = shpOrders;

    if (this.ribbonObj) {
      this.ribbonObj.ribbonComboBoxModule.updateComboBox(this.ShpOrdNoDdl, 'ShpOrdNoDdl');
    }
  }
  getallCards() {
    this.isCardsLoading = true;
    this.orderService.GetUserCardsCollections(this.currentUser.id).subscribe(response => {

      const dataResponse = response.filter(item => item.orderId !== null && item.orderItemGuid !== null)

      this.MyCardOrderItemsForGradeOrBetter = dataResponse;

      if (this.MyCardOrderItemsForGradeOrBetter.length >= 1) {
        for (let item of this.MyCardOrderItemsForGradeOrBetter) {
          item.showBackImage = false;
          item.orderNumber = item.orderNumber.toString();
        }
      }

      this.MyCardOrderItems = [...this.MyCardOrderItemsForGradeOrBetter];
      if (this.MyCardOrderItems.length >= 1) {
        for (let item of this.MyCardOrderItems) {
          if (item.cardGrade == '0 A') {
            item.cardGrade = 'AUTHENTIC'
          }
        }
        this.bindRibbonData();
      }
      this.isCardsLoading = false;

    });
  }


  buildForm() {
    this.form = this.formBuilder.group({
      authcode: new FormControl('', Validators.compose([Validators.minLength(5), Validators.maxLength(12), Validators.required])),
      grade: new FormControl(''),
      subject: new FormControl('', Validators.compose([Validators.maxLength(15)]))
    });
  }
  setAuthcodeValidators() {
    const gradeControl = this.form.get('grade');
    const subjectControl = this.form.get('subject');
    this.form?.get('authcode')?.valueChanges
      .subscribe(authcodeLength => {
        var authcodecertcode = authcodeLength.charAt(0);
        if (authcodecertcode == 'A' || authcodecertcode == 'B' || authcodecertcode == 'a' || authcodecertcode == 'b') {
          gradeControl?.setValidators(null);
          subjectControl?.setValidators(null);
          this.showgradeSubject = false;
        }
        else {
          if (authcodeLength.length > 7) {
            gradeControl?.setValidators([Validators.required]);
            subjectControl?.setValidators([Validators.required]);
            this.showgradeSubject = true;
          }
          if (authcodeLength.length === 7) {
            gradeControl?.setValidators(null);
            subjectControl?.setValidators(null);
            this.showgradeSubject = false;
          }
          if (authcodeLength.length === '') {
            gradeControl?.setValidators(null);
            subjectControl?.setValidators(null);
            this.showgradeSubject = false;
          }
        }
        gradeControl?.updateValueAndValidity();
        subjectControl?.updateValueAndValidity();
      });
  }
  CheckAuthCode() {
    this.msgColor = "";
    this.cardsMsg = "";
    this.cardAddedStatus = "";
    if (this.form.invalid) {
      return;
    }
    else {
      if (this.form.valid) {

        this.showCertCodeMsg = true;
        this.isAuthCodeRefreshing = true;

        const authCode = this.form.controls['authcode'].value;
        const grade = this.form.controls['grade'].value;
        const subject = this.form.controls['subject'].value;


        const checkCertCode = this.MyCardOrderItemsForGradeOrBetter.filter(item => item.certificationCode === authCode)
        if (checkCertCode && checkCertCode.length > 0) {
          this.authcertcode = authCode;
          this.cardAddedStatus = "cardExist";
          this.isAuthCodeRefreshing = false;
        }
        else {
          this.DataLoad(authCode, grade, subject);
        }
      }
    }
  }
  DataLoad(authCode: any, grade: any, subject: any) {
    this.popReportsService.getPopPipelineStatus().subscribe(response => {
      this.PopPipelineStatus = response;
      if (this.PopPipelineStatus.length >= 1) {
        this.PopLineheck = true
        this.popReportsService.GetCertAuthCode(authCode, grade, subject,'').subscribe(response => {
          if (response != null) {
            this.authCodeResult = response;
            if (this.authCodeResult.popResultCount == 1) {
              this.authcertcode = this.form.controls['authcode'].value;
              if (this.authcertcode.length > 7) {
                this.authcertcodelength = true;
              }
              var AuthPopLoadcheck = this.authcertcode.charAt(0);
              if (AuthPopLoadcheck == 'A' || AuthPopLoadcheck == 'B' || AuthPopLoadcheck == 'a' || AuthPopLoadcheck == 'b') {
                this.btnAuthPopLoad = false;
              }
              else {
                this.btnAuthPopLoad = true;
              }
              this.showgradeSubject = false
              this.isAuthCodeRefreshing = false;
              this.form.controls['authcode'].setValue('');
              if (this.authCodeResult.variantGenerationState == 2 && this.authCodeResult.migrationState == 2 && this.authCodeResult.id.length >= 36) {
                this.h275FrontImage = "https://sgcimagprodstorage.blob.core.windows.net/mycollections/" + this.authCodeResult.id.toLowerCase() + "/h275/front/" + this.authCodeResult.id.toLowerCase() + ".jpg";
                this.h275BackImage = "https://sgcimagprodstorage.blob.core.windows.net/mycollections/" + this.authCodeResult.id.toLowerCase() + "/h275/back/" + this.authCodeResult.id.toLowerCase() + ".jpg";
              }
              else {
              }
            }
            else if (this.authCodeResult.popResultCount! > 1) {
              this.showgradeSubject = true
              this.isAuthCodeRefreshing = false;

              const gradeControl = this.form.get('grade');
              const subjectControl = this.form.get('subject');
              gradeControl?.setValidators([Validators.required]);
              subjectControl?.setValidators([Validators.required]);
              gradeControl?.updateValueAndValidity();
              subjectControl?.updateValueAndValidity();
            }
            this.SaveCardToCollection(authCode);
          }
          else {
            this.authcertcode = this.form.controls['authcode'].value;
            this.isAuthCodeRefreshing = false;
            this.showgradeSubject = false;
            this.authCodeResult.popResultCount = 0;
            this.form.controls['authcode'].setValue('');
          }
        });
      }
      else {
        this.isAuthCodeRefreshing = false;
        this.PopLineheck = false
      }
    });
  }
  SaveCardToCollection(authCode: any) {
    var userId = this.stateService.currentUser.get().id;
    this.popReportsService.SaveCardToMyCollections(userId, authCode).subscribe(response => {
      if (response.ok) {
        this.getallCards();
        this.cardAddedStatus = "cardAdded";
      }
      else {
        if (response.error && response.error.text === 'CardAlreadyExist') {
          this.cardAddedStatus = "cardExist";
        } else if (response.error && response.error.text === 'CardAdded') {
          this.getallCards();
          this.cardAddedStatus = "cardAdded";
        }
      }
    });
  }
  removeCardFromCollection(certificationCode: any) {
    this.stateService.currentUser.changes.subscribe(user => {
      this.currentUser = user;
    });
    this.orderService.removeMyCollectionCards(this.currentUser.id, certificationCode).subscribe(response => {
      if (response.Status == 3) {
        this.cardAddedStatus = "cardRemoved";
        this.getallCards();
      }
      else {
      }
    });
  }
  LookUpQuestions() {
    this.router.navigate(['/pop-report/authcode-questions/', this.authcertcode]);
  }


  filterItems() {
    if (this.currentStep != 1) {
      this.currentStep = 1;
    }
    this.isCardsLoading = true;
    this.MyCardOrderItems = [];
    const selectedGradeNumber = this.selectedGrade ? parseFloat(this.selectedGrade.split(' ')[0]) : null;

    const filteredItems = this.MyCardOrderItemsForGradeOrBetter.filter(item => {
      let cardGradeNumber = item.cardGrade ? parseFloat(item.cardGrade.split(' ')[0]) : null;

      if (item.cardGrade) {
        let formatedGrade = item.cardGrade.trim();
        if (formatedGrade === "AUTHENTIC" || formatedGrade === "0 A") {
          cardGradeNumber = 0;
        }
      }

      return (!this.selectedSport || item.sport === this.selectedSport) &&
        (!this.selectedSet || item.cardSet === this.selectedSet) &&
        (!this.selectedSubject || item.cardSubject === this.selectedSubject) &&
        (!this.selectedYearFrom || item.yearFrom >= this.selectedYearFrom) &&
        (!this.selectedYearTo || item.yearTo <= this.selectedYearTo) &&
        (!this.selectedCardNo || item.cardNumber === this.selectedCardNo) &&

        (!this.selectedOrdNo || item.orderNumber === this.selectedOrdNo) &&
        (!this.selectedAutoOnly || item.cardAutoGrade != null) &&
        (!this.selectedCertCode || item.certificationCode === this.selectedCertCode) &&

        (this.selectedGradeOrBetter && selectedGradeNumber !== null
          ? cardGradeNumber !== null && cardGradeNumber >= selectedGradeNumber
          : true) &&


        (!this.selectedGradeOrBetter && this.selectedGrade
          ? item.cardGrade === this.selectedGrade
          : true);

    });
    for (let item of filteredItems) {
      item.showBackImage = false;
      this.MyCardOrderItems.push(item);
    }
    setTimeout(() => {
      this.isCardsLoading = false;
    }, 100);
  }
  public trackItem(index: number, item: MyCardOrderItems) {
    return item.certificationCode;
  }
  selectall() {
    _.forEach(this.MyCardOrderItems, item => {
      const orderItems = this.downlaodCardOrderItems.filter(nb => nb.itemGuid == item.orderItemId);
      if (orderItems.length >= 1) {
        const foundItem = this.downlaodCardOrderItems.find(d => d.itemGuid === item.orderItemId);
        if (foundItem) {
          foundItem.itemGuid = item.orderItemId;
          foundItem.orderNumber = item.orderNumber;
        }
      } else {
        if (item.myCardOwnerId == this.currentUser.id) {
          const downlaodCardOrderItems = new DownlaodCardOrderItems();
          downlaodCardOrderItems.itemGuid = item.orderItemId;
          downlaodCardOrderItems.orderNumber = item.orderNumber;
          item.isChecked = true;
          this.downlaodCardOrderItems.push(downlaodCardOrderItems);
        }
      }
    });
    this.TotalorderItemGuidList = this.downlaodCardOrderItems.length;
  }
  totalCardsSeleted() {
    if (this.TotalorderItemGuidList >= 1) {
      return this.TotalorderItemGuidList + " Cards Selected";
    }
    else {
      return "Cards Selection";
    }
  }
  clearall() {
    _.forEach(this.MyCardOrderItems, item => {
      item.isChecked = false;
    });
    this.downlaodCardOrderItems.length = 0;
    this.TotalorderItemGuidList = this.downlaodCardOrderItems.length;
    //if (this.ribbonObj) {
    //  this.ribbonObj.refresh();
    //  this.ribbonObj.refreshLayout();
    //}
    this.cardsMsg = "";
    this.msgColor = "";
  }
  BackFromcertCodeLookup() {
    this.authCodeResult = new PopReportAuthCode();
    this.PageMainCall();
  }

  ShowImage(item: any, showBackImage: boolean) {
    if (showBackImage == true) {
      item.showBackImage = false;
    }
    else {
      item.showBackImage = true;
    }
  }
  openImage(Image: boolean, orderItemGuid: any) {
    if (Image == false) {
      this.modalService.open('app-view-thumbnail-front-image', orderItemGuid.toLowerCase());
    }
    else {
      this.modalService.open('app-view-thumbnail-image', orderItemGuid.toLowerCase());
    }
  }
  openFrontImage(orderItemGuid: any) {
    this.modalService.open('app-view-thumbnail-front-image', orderItemGuid.toLowerCase());
  }
  openBackImage(orderItemGuid: any) {
    this.modalService.open('app-view-thumbnail-image', orderItemGuid.toLowerCase());
  }

  addToDownload(isChecked: any, itemGuid: string) {
    if (isChecked == false) {
      this.downlaodCardOrderItems.splice(this.downlaodCardOrderItems.findIndex(x => x.itemGuid == itemGuid), 1);
    }
    else {
      const orderItems = this.MyCardOrderItemsForGradeOrBetter.filter(nb => nb.orderItemId == itemGuid);
      let downlaodCardOrderItems = new DownlaodCardOrderItems();
      downlaodCardOrderItems.itemGuid = itemGuid;
      downlaodCardOrderItems.orderNumber = orderItems[0].orderNumber;
      this.downlaodCardOrderItems.push(downlaodCardOrderItems);
    }
    this.TotalorderItemGuidList = this.downlaodCardOrderItems.length;
  }
  DownloadAll() {
    this.cardsMsg = "";
    this.msgColor = "";
    if (this.downlaodCardOrderItems.length < 1) {
      this.cardsMsg = "Please select at least one card!.";
      this.msgColor = "red";
      return;
    }
    if (this.selectedDownloadType == null) {
      this.cardsMsg = "Please select a 'Download Type'.";
      this.msgColor = "red";
      return;
    }
    var Cardtype = this.selectedDownloadType;
    if (Cardtype != null && this.downlaodCardOrderItems.length >= 1) {
      this.allOrderItemGuidList = "";

      var auhCode = "null";
      if (this.downlaodCardOrderItems.length == 1) {
        var data = this.MyCardOrderItemsForGradeOrBetter.filter(nb => nb.orderNumber == this.downlaodCardOrderItems[0].orderNumber)
        auhCode = data[0].certificationCode
      }

      var ordernumber = this.downlaodCardOrderItems[0].orderNumber;
      const oNumCount = this.MyCardOrderItemsForGradeOrBetter.filter(nb => nb.orderNumber == ordernumber);
      const ordNumCount = this.downlaodCardOrderItems.filter(nb => nb.orderNumber == ordernumber);

      if (oNumCount.length != ordNumCount.length) {
        ordernumber = "0";
      }

      for (let item of this.downlaodCardOrderItems) {
        this.allOrderItemGuidList = this.allOrderItemGuidList + "" + item.itemGuid + Cardtype + ",";
      }
      this.orderService.downloadMyCards(this.allOrderItemGuidList.slice(0, -1), this.currentUser.id, Number(ordernumber), auhCode).subscribe(response => {
        if (response.status == "Success") {
          //this.cardsMsg = "Your download request is in process. To see if your cards are ready to download, click 'Downloads' or the 'Pending Downloads' menu next to Home.";
          //this.msgColor = "green";
          this.willBeReadySoon = this.willBeReadySoon + 1;
          if (this.willBeReadySoon > 0) {
            if (this.ribbonObj) {
              const tabadd = this.ribbonObj.tabsInternal[3];
              if (!tabadd || tabadd == undefined) {
                this.ribbonObj.addTab(this.PDownloadTab);
              }
              this.PDownloadTab = { ...this.PDownloadTab, header: "Pending Downloads " + "(" + this.willBeReadySoon + ")" };
              this.ribbonObj.updateTab(this.PDownloadTab);
            }
          }
          else {
            if (this.ribbonObj) {
              const tabadd = this.ribbonObj.tabsInternal[3];
              if (tabadd) {
                this.ribbonObj.removeTab('PDownloads');
              }
            }
          }

          this.cardsMsg = "";
          this.msgColor = "";
          this.CheckCardDownloadStatus();
        }
        if (response.status == "Failed") {
          this.cardsMsg = "We could not process your download request. Please try again later.";
          this.msgColor = "red";
        }
        if (response.status == "Failed. Request already exists.") {
          this.cardsMsg = "Your download request already exists. To see if your cards are ready to download, please click the 'Downloads' tab.";
          this.msgColor = "red";
        }

        this.clear();
      });
    }
  }

  get275AuthImageFront(id: any): string {

    return "https://sgcimagprodstorage.blob.core.windows.net/mycollections/" + id.toLowerCase() + "/h275/front/" + id.toLowerCase() + ".jpg";
  }
  get275AuthImageBack(id: any): string {
    return "https://sgcimagprodstorage.blob.core.windows.net/mycollections/" + id.toLowerCase() + "/h275/back/" + id.toLowerCase() + ".jpg";
  }
  get692AuthImageFront(id: any): string {
    return "https://sgcimagprodstorage.blob.core.windows.net/mycollections/" + id.toLowerCase() + "/h692/front/" + id.toLowerCase() + ".jpg";
  }
  get692AuthImageBack(id: any): string {
    return "https://sgcimagprodstorage.blob.core.windows.net/mycollections/" + id.toLowerCase() + "/h692/back/" + id.toLowerCase() + ".jpg";
  }
  get1000AuthImageFront(id: any): string {
    return "https://sgcimagprodstorage.blob.core.windows.net/mycollections/" + id.toLowerCase() + "/h1000/front/" + id.toLowerCase() + ".jpg";
  }
  get1000AuthImageBack(id: any): string {
    return "https://sgcimagprodstorage.blob.core.windows.net/mycollections/" + id.toLowerCase() + "/h1000/back/" + id.toLowerCase() + ".jpg";
  }

  ShowtwoCol() {
    this.currentStep = 1;
    this.currentCardGrid = 2;
  }
  ShowfourCol() {
    this.currentStep = 1;
    this.currentCardGrid = 4;
  }
  ShowsixCol() {
    this.currentStep = 1;
    this.currentCardGrid = 6;
  }
  ShowoneCol() {
    this.currentStep = 1;
    this.currentCardGrid = 1;
  }

  OpenConfirmationModal(item: any) {
    this.modalService.open('app-delete-card', { item, resultCallback: this.onModalResult.bind(this) });
  }

  onModalResult(result: string, certificationCode: string) {
    if (result == 'yes') {
      this.stateService.currentUser.changes.subscribe(user => {
        this.currentUser = user;
      });
      this.orderService.removeMyCollectionCards(this.currentUser.id, certificationCode).subscribe(response => {
        if (response.Status == 3) {
          this.toastr.success("Card removed successfully.", "Success", {
            progressBar: true,
            timeOut: 60000,
            progressAnimation: "decreasing"
          });
          this.getallCards();
        }
        else {
          this.toastr.error("Card not removed successfully.", "Error", {
            progressBar: true,
            timeOut: 60000,
            progressAnimation: "decreasing"
          });
        }

      });
    }
  }

  clear() {
    _.forEach(this.MyCardOrderItems, item => {
      item.isChecked = false;
      item.showBackImage = false;
    });
    this.TotalorderItemGuidList = 0;
    this.downlaodCardOrderItems.length = 0;
    this.MyCardOrderItems = [];
    this.MyCardOrderItems = this.MyCardOrderItemsForGradeOrBetter;
  }
  ngOnDestroy(): void {
    if (this.fetchInterval) {
      this.fetchInterval.unsubscribe();
    }
  }
}
